<div class="page-info">
    <div class="page-info__content">
        <h1 class="page-info__content--title">{{title}}</h1>
        <h2 class="page-info__content--subtitle" *ngIf="subTitle">{{subTitle}}</h2>
        <ng-container [ngTemplateOutlet]="subTitleTemplate" *ngIf="subTitleTemplate"></ng-container>
    </div>
</div>
